import cx from 'classnames';
import React, { forwardRef, HTMLProps, LegacyRef } from 'react';

import { FormControl } from './form-control';

export const Input = forwardRef(
  (
    {
      id,
      label,
      error,
      required,
      className,
      inputClassName,
      hideLabel,
      ...props
    }: {
      error?: string;
      hideLabel?: boolean;
      inputClassName?: string;
    } & HTMLProps<HTMLInputElement>,
    ref: LegacyRef<HTMLInputElement> | undefined,
  ) => {
    const fieldId = id || props.name || '';
    return (
      <FormControl
        id={fieldId}
        error={error}
        label={label}
        className={className}
        hideLabel={hideLabel}
        required={required}
      >
        <div className="flex items-center">
          <input
            ref={ref}
            id={fieldId}
            required={required}
            className={cx(
              'disabled:bg-grey-300 mb-2 w-full overflow-hidden text-ellipsis whitespace-nowrap rounded-sm border border-solid border-gray-300 px-3 py-2 text-sm text-gray-800 focus:outline-blue-500 enabled:bg-white',
              {
                'ring-2 ring-red-500': !!error,
              },
              inputClassName,
            )}
            {...props}
          />
        </div>
      </FormControl>
    );
  },
);

Input.displayName = 'Input';
